export enum LoginMethod {
  ANY = 'a',
  WITH_CREDENTIALS = 'c',
  WITH_GOOGLE = 'g',
}
